<template>
  <div class="developmentIdea">
    <article v-for="item in introduceList">
      <h4>{{item.title}}</h4>
      <div>
        <span v-html='item.describe'></span>
      </div>
    </article>

  </div>
</template>

<script>
export default {
  name: "developmentIdea",
  data() {
    return {
      introduceList: [],
    };
  },
  created() {
    this.getIntroduceList();
  },
  methods: {
    getIntroduceList() {
      let self = this;
      const req = {
        index: 1,
        size: 10,
      };
      this.$http
        .post("article/pageSelect/" + req.index + "/" + req.size, {})
        .then((data) => {
          if (data.body.success) {
            for (var i in data.body.data) {
              self.introduceList.push(data.body.data[i]);
            }
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  text-align: left;
  text-indent: 6px;
  font-family: 微软雅黑;
  letter-spacing: 1px;
  color: #2d2d2d;
  font-size: 13px;
  line-height: 26px;
}
h4 {
  font-size: 16px;
  font-weight: border;
  color: black;
}

.developmentIdea {
  margin-bottom: 50px;
}
article {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduce/developmentIdea.vue